/**************************************************
 * Nombre:       Tarjeta_Icono
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, IconButton, Typography} from "@mui/material";
import {FiberManualRecord} from '@mui/icons-material'
import {irUrl} from "../../Utilidades/irUrl";

const Tarjeta_Icono = ({titulo, texto, indicador, icono, color = '#4AFF83', colorTexto = '#000', url}) => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-end'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                borderRadius: 4,
                background: 'rgba(255, 255, 255, 0.20)',
                backdropFilter: 'blur(5px)',
                py: 2,
                px: 2,
                color: '#fff'
            }}
        >

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{fontSize: 16, fontWeight: 400, letterSpacing: 6}}>{titulo}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                <Typography sx={{
                    fontSize: 9,
                    fontWeight: 400,
                    backgroundColor: color,
                    color: colorTexto,
                    pl: 1,
                    pr: 1,
                    pb: 0.4,
                    borderRadius: 6,
                    letterSpacing: 2
                }}>{indicador}
                    <FiberManualRecord sx={{fill: '#000', width: 14, height: 14, mt: 0.4, mb: -0.4, pl: 0.5}}/>
                </Typography>
            </Grid>

            <Grid container size={{xs: 10, sm: 12, md: 10}} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{fontSize: 14, fontWeight: 400, letterSpacing: 1}}>{texto}</Typography>
            </Grid>

            <Grid container size={{xs: 2, sm: 12, md: 2}} sx={{justifyContent: 'flex-end'}}>
                <IconButton
                    onClick={() => irUrl(url)}
                    sx={{p: 0}}
                >
                    <img src={icono} width={52} height={'auto'}/>
                </IconButton>

            </Grid>

        </Grid>
    )

}
export default Tarjeta_Icono